import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { LinkLoyaltyService } from './services/linkLoyalty.service';
import { environment } from "environments/environment";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-loyalty',
  templateUrl: './linkLoyalty.component.html',
  styleUrls: ['./linkLoyalty.component.css'],
  providers: [LinkLoyaltyService]

})
export class LinkLoyaltyComponent implements OnInit {

  @Input() init: number = null;
  constructor(
    public httpClient: HttpClient,
    public linkLoyaltyService: LinkLoyaltyService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
  ) {
  }

  public counter: number = 180;
  public isPhone: boolean = true
  public phoneSaleout: string;
  public otpSaleout: string;
  public checkOTP: boolean = false;
  public succesSaleout: boolean = false;

  startCoutdowm() {
    if (this.counter > 0) {
      this.doCountdown();
    }
  }

  doCountdown() {
    setTimeout(() => {
      this.counter = this.counter - 1;
      this.processCountdown();
    }, 1000)
  }

  processCountdown() {
    if (this.counter == 0) {
      console.log("count is ", this.counter);
    }
    else {
      this.doCountdown();
    }
  }

  ngOnInit() {
  }

  checkPhoneSaleout() {
    console.log("TuanBA: " + this.phoneSaleout)
    if (!this.phoneSaleout) {
      this.toastr.warning(this.translate.instant('SDT_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }

    this.linkLoyaltyService.checkPhone(this.phoneSaleout).subscribe((res) => {
      if (res.status === 200) {
        this.checkOTP = true;
        this.isPhone = false;
        this.startCoutdowm();
        if (this.counter == 0) {
          this.counter = 180;
          this.startCoutdowm();
        }
        this.toastr.success(res.data, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
        return;
      }
    },
      (error) => {
        this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
          timeOut: 2000,
          positionClass: "toast-bottom-right",
        });
      }
    );
  }

  verifyOtpSaleout() {
    let body = {
      phone: this.phoneSaleout,
      otp: this.otpSaleout,
      systemType: 1
    }

    if (!body.otp) {
      this.toastr.warning(this.translate.instant('MA_OTP_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      return;
    }
    if (!body.phone) {
      this.toastr.warning(this.translate.instant('SDT_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      return;
    }

    console.log("tuanday" + body.phone, body.otp)
    this.linkLoyaltyService.verifyOTP(body).subscribe((res) => {
      if (res.error == false) {
        this.checkOTP = false;
        this.succesSaleout = true
      } else {
        this.toastr.warning(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 2000,
        positionClass: "toast-bottom-right",
      });
    }
    );
  }

  loyalty() {
    window.open(`https://loyalty.icheck.vn/auth/login`);
    // this.router.navigateByUrl('/qrcode/integrate-loyalty');
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/linkLoyalty/linkLoyalty.component.ts